var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.params.data)?_c('div',{attrs:{"align":"center"}},[_c('ButtonComponent',{attrs:{"icon":_vm.params.icon,"action":_vm.params.action,"title":_vm.params.title,"actionParams":_vm.params.data,"btnClass":_vm.params.btnClass,"disabled":_vm.disabled}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }